(function() {
	'use strict';

	angular
		.module('pwc.services.barcode')
		.factory('BarcodeFactory', BarcodeFactory);

	BarcodeFactory.$inject = ['$q', 'lodash', '$log', '$window'];

	function BarcodeFactory($q, lodash, $log, $window) {

		// String reverse
		String.prototype.reverse = function(){
			var splitext = this.split("");
			var revertext = splitext.reverse();
			return revertext.join("");
		};

		// function to calculate EAN / UPC checkdigit
		function eanCheckDigit(s)
		{
			var result = 0;
			var rs = s.reverse();
			var counter;
			for (counter = 0; counter < rs.length; counter++)
			{
				result = result + parseInt(rs.charAt(counter)) * Math.pow(3, ((counter+1) % 2));
			}
			return (10 - (result % 10)) % 10;
		}

		return function(barcodeString, type, el) {

			var deferred = $q.defer();

			var bw = new $window.BWIPJS();

			var barcodeType = type || 'upca';

			var renderId = el || 'canvas';

			var barcodeId = barcodeString;

			if (barcodeString.length === 11){
				barcodeId += eanCheckDigit(barcodeString);
			}

			$window.BWIPJS.ft_monochrome(0);
			bw.bitmap(new $window.Bitmap());
			bw.scale(2, 2);

			bw.push(barcodeId);
			bw.push('includetext');

			bw.call(barcodeType, function(e) {
				if (lodash.isNotEmptyOrNull(e)){
					$log.debug('Barcode Error:', e);
					deferred.reject(e);
				} else {
					bw.bitmap().show(renderId, 'N');
					deferred.resolve(barcodeId);
				}
			});

			return deferred.promise;
		};

	}

})();
